export enum MerchantAssetModal {
    none,
    addNewAsset = 'addNewAsset',
    editAssetData = 'editAssetData',
    createAssetListing = 'createAssetListing',
    assetAuthentication = 'assetAuthentication'
}
